import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { keyframes } from '@mui/system';

// Reuse the pulse animation from TopNav
const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const Footer = () => {
  const theme = useTheme();
  const { mode } = theme.palette;
  const currentYear = new Date().getFullYear();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width={1}
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <Box>
            <Box display="flex" flexWrap="wrap" alignItems="center">
              <Box marginTop={1} marginRight={2}>
                <Link
                  underline="none"
                  component="a"
                  href="/careers/"
                  color="text.primary"
                  variant="subtitle2"
                >
                  Careers
                </Link>
              </Box>
              <Box marginTop={1} marginRight={2}>
                <Link
                  underline="none"
                  component="a"
                  href="/virtual-tour"
                  color="text.primary"
                  variant="subtitle2"
                >
                  Virtual Tour
                </Link>
              </Box>
            </Box>
          </Box>
          <Box display="flex" flexWrap="wrap" alignItems="center">
            <Box marginTop={1} marginRight={2}>
              <Link
                underline="none"
                component="a"
                href="/facilities"
                color="text.primary"
                variant="subtitle2"
              >
                Facilities
              </Link>
            </Box>
            <Box marginTop={1} marginRight={2}>
              <Link
                underline="none"
                component="a"
                href="/contact-us"
                color="text.primary"
                variant="subtitle2"
              >
                Contact Us
              </Link>
            </Box>

            {/* Social Icons with animation */}
            <Box display="flex" alignItems="center" marginTop={1}>
              <Link
                href="https://www.facebook.com/p/National-Public-School-Yeshwanthpur-100084410342747/"
                target="_blank"
                rel="noopener"
                sx={{
                  marginLeft: 2,
                  color: '#1877F2',
                  animation: `${pulse} 2s infinite`,
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.3) rotate(5deg)',
                    color: '#1256c2',
                  },
                }}
              >
                <FacebookIcon fontSize="medium" />
              </Link>
              <Link
                href="https://www.instagram.com/nps_ypr/"
                target="_blank"
                rel="noopener"
                sx={{
                  marginLeft: 2,
                  color: '#E4405F',
                  animation: `${pulse} 2s infinite`,
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.3) rotate(-5deg)',
                    color: '#C13584',
                  },
                }}
              >
                <InstagramIcon fontSize="medium" />
              </Link>
            </Box>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Typography align="center" variant="subtitle2" color="text.secondary" gutterBottom>
          Phone : <a href="tel:+91 8029501184">+91 8029501184</a>,
          <a href="tel:+91 8023571220"> +91 8023571220</a>
          <br />
          Email : <a href="mailto:info@npsypr.edu.in">info@npsypr.edu.in</a>,
          <a href="mailto:admissions@npsypr.edu.in"> admissions@npsypr.edu.in</a>
        </Typography>
        <Typography align="center" fontSize="x-small">
          © 2013 - {currentYear} by NPS Yeshwanthpur. All Rights Reserved.
          Designed by <span style={{ color: '#E31E25' }}>K</span>
          <span style={{ color: '#19A9E4' }}>N</span>
          <span style={{ color: '#67AE3B' }}>R</span> Tech Solutions for SZI.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Footer;
